import { shouldUseLocalizedShortcuts, type Hotkeys, type KeyboardKeys } from 'owa-hotkeys';
import { getCurrentCulture } from 'owa-localize';

type LocalizedMailCommand = 'find' | 'forward';
type MailShortcutLocale = 'da' | 'de' | 'nb' | 'nn' | 'sv';
type LocalizedMailHotkeyProfile = Partial<Record<LocalizedMailCommand, KeyboardKeys>>;

// These values also override Outlook for Web defaults (Find: Ctrl+F; Forward: Shift+F/Ctrl+Shift+F).
const localizedMailHotkeys: Record<MailShortcutLocale, LocalizedMailHotkeyProfile> = {
    da: {
        find: 'ctrl+shift+f',
        forward: 'ctrl+f',
    },
    de: {
        find: 'ctrl+f',
        forward: 'ctrl+shift+f',
    },
    nb: {
        find: 'ctrl+shift+f',
        forward: 'ctrl+f',
    },
    nn: {
        find: 'ctrl+shift+f',
        forward: 'ctrl+f',
    },
    sv: {
        find: 'ctrl+shift+f',
        forward: 'ctrl+f',
    },
};

export function getLocalizedMailHotkey(
    command: LocalizedMailCommand,
    defaultHotkey: KeyboardKeys
): KeyboardKeys;
export function getLocalizedMailHotkey(
    command: LocalizedMailCommand,
    defaultHotkey: Hotkeys
): Hotkeys;
export function getLocalizedMailHotkey(
    command: LocalizedMailCommand,
    defaultHotkey: Hotkeys
): Hotkeys {
    if (!shouldUseLocalizedShortcuts()) {
        return defaultHotkey;
    }

    const culture = getCurrentCulture().toLowerCase();
    const language = culture.split('-')[0];
    const shortcutLocale = isMailShortcutLocale(culture)
        ? culture
        : isMailShortcutLocale(language)
          ? language
          : undefined;

    return shortcutLocale
        ? (localizedMailHotkeys[shortcutLocale][command] ?? defaultHotkey)
        : defaultHotkey;
}

function isMailShortcutLocale(locale: string): locale is MailShortcutLocale {
    return Object.prototype.hasOwnProperty.call(localizedMailHotkeys, locale);
}
